// extracted by css-extract-rspack-plugin
export default {"optionsWrap":"BirthdaysMenu_optionsWrap__7mEbI","name":"BirthdaysMenu_name__fVP8h"};